module.exports = __webpack_public_path__ + "media/images/magnifying_glass_icon-f20720ce.png";